import SearchIcon from '@mui/icons-material/Search';
import classNames from 'classnames';
import LazyTextField, { LazyTextFieldProps } from '../LazyTextField';
import { useSearchFieldStyles } from './search.styles';

const LazySearchField = (props: LazyTextFieldProps) => {
  const { classes } = useSearchFieldStyles();

  return (
    <LazyTextField
      size="small"
      variant="outlined"
      color="primary"
      className={classNames(classes.searchTextField, classes.searchInput)}
      slotProps={{
        input: {
          startAdornment: (
            <SearchIcon fontSize="small" color="disabled" className={classes.searchIcon} />
          ),
          className: classes.searchInput,
        },
      }}
      {...props}
    />
  );
};

export default LazySearchField;
